module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirts.52f5b850.svg";